import { render, staticRenderFns } from "./StatisticPage5.vue?vue&type=template&id=2b1976c4&scoped=true"
import script from "./StatisticPage5.vue?vue&type=script&lang=js"
export * from "./StatisticPage5.vue?vue&type=script&lang=js"
import style0 from "./StatisticPage5.vue?vue&type=style&index=0&id=2b1976c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1976c4",
  null
  
)

export default component.exports